let config = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  PRODUCT_NAME: process.env.REACT_APP_PRODUCT_NAME,
  PRODUCT_LOGO: process.env.REACT_APP_PRODUCT_LOGO,
  CUSTOMER_LOGO: process.env.REACT_APP_CUSTOMER_LOGO,
  TIME_FORMATE: process.env.REACT_APP_DATE_FORMATE,
  TIME_FORMATE_WITH_TIME: process.env.REACT_APP_DATE_FORMATE_WITH_TIME,
  STDLABELSIZE:process.env.STDLABELSIZE
};

export default config;
